import React from "react";

const CustomerDetails = () => {
  return (
    <div class="flex items-center justify-center h-screen">
      <h1 class="text-4xl font-semibold text-secondary">Coming Soon</h1>
    </div>
  );
};

export default CustomerDetails;
